import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate} from "../util/helpers";

export default function ChatMain() {
    const displayChatStatus = (status) => {
        switch (status) {
            case "CREATED":
                return "대화중";
            case "PAID":
                return "결제완료";
            case "CONSULTING":
                return "상담중";
            case "COMPLETED":
                return "진행종료";
            case "REFUNDED":
                return "환불";
            default:
                return status;
        }
    };
    const getStatusColor = (status) => {
        switch (status) {
            case "CREATED":
                return "#6c757d"; // 회색 톤 (대화 생성/대기)
            case "PAID":
                return "#17a2b8"; // 청록 (결제완료)
            case "CONSULTING":
                return "#28a745"; // 초록 (상담중)
            case "COMPLETED":
                return "#007bff"; // 파랑 (진행종료)
            case "REFUNDED":
                return "#dc3545"; // 빨강 (환불)
            default:
                return "inherit";
        }
    };
    const [paginationDto, setPaginationDto] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") || '1';
    const searchType = searchParams.get("searchType") || 'CHATROOM_ID'; // CHATROOM_ID | BUYER_ID | SELLER_ID
    const keyword = searchParams.get("keyword") || '';
    const status = searchParams.get("status") || '';

    const requestData = () => {
        const params = {};
        params.page = page;
        if (searchType) params.searchType = searchType;
        if (keyword) params.keyword = keyword;
        if (status) params.status = status;

        axios.get(`/admin/v1/chatrooms`, {params})
                .then((res) => {
                    setPaginationDto(res.data);
                    setResults(res.data.content || []);
                });
    };

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage(1);
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searchType, keyword, status]);

    return (
            <div className="App">
                <div className="wrapper">
                    <div className="content-wrapper" style={{marginLeft: '0px'}}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-12">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item active">매칭관리 &gt; 매칭 목록</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-tools" style={{marginTop: '40px'}}>
                                                <div className="form-group row" style={{float: "right"}}>

                                                    <label className="col-sm-auto col-form-label"
                                                           style={{marginLeft: '10px'}}>검색</label>

                                                    <select className="form-control float-right"
                                                            style={{width: '160px', marginRight: '10px'}}
                                                            onChange={e => {
                                                                searchParams.set("page", '1');
                                                                searchParams.set("searchType", e.target.value);
                                                                setSearchParams(searchParams);
                                                            }}
                                                            value={searchType}>
                                                        <option value="CHATROOM_ID">매칭 ID</option>
                                                        <option value="BUYER_ID">유저ID(구매자)</option>
                                                        <option value="SELLER_ID">유저ID(판매자)</option>
                                                    </select>

                                                    <input type="text" className="form-control float-right"
                                                           style={{width: '220px', marginRight: '20px'}}
                                                           placeholder="검색어를 입력하세요"
                                                           value={keyword}
                                                           onChange={e => {
                                                               searchParams.set("page", '1');
                                                               searchParams.set("keyword", e.target.value);
                                                               setSearchParams(searchParams);
                                                           }}
                                                           onKeyDown={e => {
                                                               if (e.key === 'Enter') {
                                                                   e.preventDefault();
                                                                   search();
                                                               }
                                                           }}
                                                    />

                                                    <label className="col-sm-auto col-form-label"
                                                           style={{marginLeft: '10px'}}>매칭상태</label>
                                                    <select className="form-control float-right"
                                                            style={{width: '180px', marginRight: '20px'}}
                                                            onChange={e => {
                                                                searchParams.set("page", '1');
                                                                searchParams.set("status", e.target.value);
                                                                setSearchParams(searchParams);
                                                            }}
                                                            value={status}>
                                                        <option value="">모두</option>
                                                        <option value="CREATED">대화중</option>
                                                        <option value="PAID">결제완료</option>
                                                        <option value="CONSULTING">상담중</option>
                                                        <option value="COMPLETED">진행종료</option>
                                                        <option value="REFUNDED">환불</option>
                                                    </select>

                                                    <button type="submit" className="btn btn-info float-right"
                                                            style={{width: '80px', marginRight: '10px'}}
                                                            onClick={search}>
                                                        검색
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                                <table className="table table-hover text-nowrap"
                                                       style={{textAlign: "center"}}>
                                                    <thead>
                                                    <tr>
                                                        <th>매칭ID</th>
                                                        <th>게시글 제목</th>
                                                        <th>구매자 ID</th>
                                                        <th>판매자 ID</th>
                                                        <th>매칭 일시</th>
                                                        <th>매칭 상태</th>
                                                        <th>상세보기</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {results && results.map(item => (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    <a href={`/page/insights/detail?id=${item.insightId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{item.insightTitle}</a>
                                                                </td>
                                                                <td>
                                                                    <a href={`/page/users/detail?userId=${item.buyerId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{item.buyerId}</a>
                                                                </td>
                                                                <td>
                                                                    <a href={`/page/users/detail?userId=${item.sellerId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{item.sellerId}</a>
                                                                </td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                                <td style={{
                                                                    color: getStatusColor(item.status),
                                                                    fontWeight: 600
                                                                }}>
                                                                    {displayChatStatus(item.status)}
                                                                </td>
                                                                <td>
                                                                    <Link to={`/page/chat/detail?id=${item.id}`} className="btn btn-outline-info">
                                                                        보기
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>}

                        </section>
                    </div>
                </div>
            </div>
    );
}
